import axios from "axios";

const instance = axios.create();
const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute("content");

axios.interceptors.request.use(function (config) {
  config.headers["X-CSRF-TOKEN"] = csrfToken;
  return config;
});

export default instance;
